import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { MDBDataTableV5, MDBCol, MDBTableBody, MDBTableHead } from "mdbreact";
import { Link } from "react-router-dom";

import Notiflix from "notiflix";
import PostApiCall from "../../Api";
import GetApiCall from "../../GETAPI";
import moment from "moment";
import Parser from "html-react-parser";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

class customerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,

      UserData: [],
      Id: "",
      searchInput: "",
    };
  }

  componentDidMount() {
    Notiflix.Loading.Init({
      svgColor: "rgb(216, 23, 100)",
    });

    Notiflix.Loading.Dots("");
    var login = localStorage.getItem("LoginDetail");
    var details = JSON.parse(login);
    // console.log(details[0])
    this.setState({
      Usertype: details[0].fld_usertype,
    });
    console.log("this.state.Usertype  " + this.state.Usertype )
    if (details[0].fld_usertype != "Admin")
    {
      window.location.href = "/"
      }

    GetApiCall.getRequest("Get_CustomerList").then((resultdes) =>
      resultdes.json().then((obj) => {
        console.log(obj.data);

        this.setState({
          UserData: obj.data,
        });

        Notiflix.Loading.Remove();
      })
    );
  }

  // fld_aadharcardupload: "http://demo.globaltrendz.online/maxxchange/images/userpdf/shivani-2.pdf"
  // fld_accountno: "5425342534253"
  // fld_adhaar: "145425423423"
  // fld_bankname: "SBI"
  // fld_branch_name: "Moti Nagar"
  // fld_createdon: "Feb 14, 2021 11:23 PM"
  // fld_dateofanniversary: ""
  // fld_dateofbirth: "2021-02-14"
  // fld_department: "Admin"
  // fld_designation: "Manager"
  // fld_drivinglicense: "4524534345"
  // fld_drivingupload: null
  // fld_email: "projects@globaltrendz.com"
  // fld_gender: "Female"
  // fld_ifsccode: "test234"
  // fld_mobile: "8979218769"
  // fld_name: "shivani"
  // fld_pan: "542534343g"
  // fld_pancardupload: null
  // fld_password: "c57de3b9fdca01696f177248a499ee5154a0f26945fd05b92c9f2fa6ad72b938d4daf7c79ede1b969d23cb48fb2c59e446c7590390872e203f136c9462d031c5"
  // fld_photo: "http://demo.globaltrendz.online/maxxchange/images/RawMaterial/shivani-2.jpg"
  // fld_presentaddress: "Delhi"
  // fld_presentcity: "Ágasegyháza"
  // fld_presentcountry: "Hungary"
  // fld_presentpincode: "110008"
  // fld_presentstate: "Bács-Kiskun County"
  // fld_salary: 20000
  // fld_salt: "934C106B-784C-43A9-BD3E-6872D8768492"
  // fld_status: "Active"
  // fld_updatedby: 1
  // fld_updatedon: "Feb 14, 2021 11:23 PM"
  // fld_userid: 2
  // fld_usertype: "Admin"

  seachBarHandler = (e) => {
    this.setState({ ...this.state, searchInput: e.target.value });
  };
  render() {
    const data = {
      columns: [
        {
          label: "S.No.",
          field: "serial",
          sort: "disabled",
          width: 150,
        },
        {
          label: "Customer Name",
          field: "name",
          sort: "disabled",
          width: 400,
        },

        {
          label: "Mobile Number",
          field: "mobileno",
          sort: "disabled",
          width: 150,
        },
        {
          label: "Email",
          field: "email",
          sort: "disabled",
          width: 150,
        },

        {
          label: "User Status",
          field: "status",
          sort: "disabled",
          width: 150,
        },

        {
          label: "Action",
          field: "action",
          sort: "disabled",
          width: 100,
        },
      ],
      rows: this.state.UserData.filter((data) => {
        console.log(data.fld_email.toLowerCase(), this.state.searchInput);
        let name = [
          ...data.fld_name
            .toLowerCase()
            .matchAll(this.state.searchInput.toLowerCase()),
        ];

        if (this.state.searchInput.length > 0 && name[0]) {
          return data;
        }

        if (
          this.state.searchInput.length > 0 &&
          data.fld_email.toLowerCase() === this.state.searchInput.toLowerCase()
        ) {
          return data;
        }
        if (
          this.state.searchInput.length > 0 &&
          data.fld_mobile.toLowerCase() === this.state.searchInput.toLowerCase()
        ) {
          return data;
        }

        if (
          this.state.searchInput.length > 0 &&
          data.fld_status.toLowerCase() === this.state.searchInput.toLowerCase()
        ) {
          return data;
        }

        if (this.state.searchInput.length == 0) {
          return data;
        }
      }).map((data, i) => {
        return {
          serial: <td>{i + 1}</td>,
          name: <td>{data.fld_name}</td>,
          designation: <td>{data.fld_designation}</td>,
          department: <td>{data.fld_department}</td>,

          mobileno: <td>{data.fld_mobile}</td>,
          email: <td>{data.fld_email}</td>,
          usertype: <td>{data.fld_usertype}</td>,
          status: <td>{data.fld_status}</td>,

          action: (
            <td className="text-center actionuser">
              {/* <i className="fas fa-eye btn" style={{fontSize:'15px',marginTop:'-11px'}}></i> */}
              <i
                className="fas fa-edit btn"
                style={{ fontSize: "15px", marginTop: "-11px" }}
                onClick={() => {
                  localStorage.setItem("customerdetails", JSON.stringify(data));
                  window.location.href = "/editCustomer";
                }}
              ></i>
              <span className="btn" style={{ marginTop: "-9px" }}>
                <i
                  className="fa fa-trash py-auto "
                  aria-hidden="true"
                  style={{ fontSize: "15px" }}
                  onClick={() => {
                    confirmAlert({
                      title: "Confirm to Delete",
                      message: "Are you sure you want to delete customer.",
                      buttons: [
                        {
                          label: "Yes",
                          onClick: () => {
                            Notiflix.Loading.Dots("");

                            PostApiCall.postRequest(
                              {
                                id: data.fld_customerid,
                                status: "Disabled",
                              },
                              "Delete_Customer"
                            ).then((results) =>
                              // const objs = JSON.parse(result._bodyText)
                              results.json().then((obj) => {
                                if (
                                  results.status == 200 ||
                                  results.status == 201
                                ) {
                                  Notiflix.Loading.Remove();
                                  Notiflix.Notify.Success(
                                    "User successfully deleted."
                                  );
                                  window.location.reload();
                                } else {
                                  Notiflix.Loading.Remove();
                                  Notiflix.Notify.Failure(
                                    "Something went wrong, try again later."
                                  );
                                }
                              })
                            );
                          },
                        },
                        {
                          label: "No",
                          // onClick: () => alert('Click No')
                        },
                      ],
                    });
                  }}
                />
              </span>
            </td>
          ),
        };
      }),
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={"Max Xchange / Customer Management"}
              breadcrumbItem={"Customer List"}
            />
            <Row>
              <Col xl="12">
                <Card className="overflow-hidden">
                  <div
                    className="maxXchange-bg-soft-pink"
                    style={{ background: "rgb(216, 23, 100)" }}
                  >
                    <Row>
                      <Col xs="6">
                        <div className="maxXchange-text p-3">
                          <h5 className="maxXchange-text text-white">
                            Customer Management
                          </h5>
                        </div>
                      </Col>
                    </Row>
                    <Row></Row>
                  </div>
                  <Card className="overflow-hidden">
                    <Row>
                      <Col xl="12">
                        <Card className="overflow-hidden">
                          <div className="maxXchange-bg-soft-pink">
                            <Row>
                              <Col xs="6">
                                <div className="maxXchange-text p-3">
                                  <h5 className="maxXchange-text">
                                    Customer List
                                  </h5>
                                </div>
                              </Col>
                              <Col xs="6">
                                <div className="maxXchange-text p-3">
                                  <Link
                                    to="/add_customer"
                                    style={{
                                      float: "right",
                                      marginTop: "-5px",
                                    }}
                                    className="btn align-items-center btn maxXchange-btn "
                                  >
                                    Add New Customer{" "}
                                    <i
                                      className="fa fa-plus"
                                      aria-hidden="true"
                                    ></i>
                                  </Link>
                                </div>
                              </Col>
                            </Row>
                          </div>
                          <CardBody className="pt-0">
                            <Row></Row>
                          </CardBody>
                          <CardBody className="pt-0">
                            <Row>
                              <MDBCol md="3" style={{ marginBottom: "10px" }}>
                                <input
                                  className="form-control"
                                  type="text"
                                  placeholder="Search"
                                  aria-label="Search"
                                  onChange={(e) => this.seachBarHandler(e)}
                                  value={this.state.searchInput}
                                />
                              </MDBCol>
                              <Col md="12">
                                <MDBDataTableV5
                                  striped
                                  bordered
                                  small
                                  data={data}
                                  searchBottom={false}
                                  seachTop={true}
                                >
                                  <MDBTableHead columns={data.columns} />
                                  <MDBTableBody rows={data.rows} />
                                </MDBDataTableV5>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>

                        {/* <WelcomeComp /> */}
                      </Col>
                    </Row>
                  </Card>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default customerList;
